import {BaseField} from "../base-field";

export class RadioField<T = any> extends BaseField<T> {
    public values?: RadioFieldItem[];
    public onValueSelectedFunc?: (value: any) => any;

    constructor(init: Partial<RadioField<T>>) {
        super('Radio', init);
        if (!init.css) {
            this.css = 'col-4'
        }
    }
}

export interface RadioFieldItem {
    value: string;
    text: string;
}
